import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const userApi = {
  getUsers: async (filters: any = {}) => {
    const { search, isActive, subscriptionFilter, page = 1, limit = 20, sortBy, sortOrder } = filters;
    let url = `${API_URL}/api/admin/users?page=${page}&limit=${limit}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (isActive !== undefined) {
      url += `&isActive=${isActive}`;
    }
    if (subscriptionFilter) {
      url += `&subscriptionFilter=${subscriptionFilter}`;
    }
    if (sortBy) {
      url += `&sortBy=${sortBy}`;
    }
    if (sortOrder) {
      url += `&sortOrder=${sortOrder}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getUserDetails: async (userId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getWallet: async (userId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/users/${userId}/wallet`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });
    return response.data;
  },

  addWalletCredit: async (userId: string, credit: { amount: number; reason: string; requestId: string; displayTitle?: string }) => {
    const response = await axios.post(`${API_URL}/api/admin/users/${userId}/wallet/credits`, credit, {
      headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });
    return response.data;
  },

  updateUserStatus: async (userId: string, isActive: boolean) => {
    const response = await axios.put(
      `${API_URL}/api/admin/users/${userId}/status`,
      { isActive },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },
};

export default userApi;
